<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/cataloge-mapping/user" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateUsersCatalogue") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.UserName")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.UserName')"
                >
                  <v-select
                    label="username"
                    :options="ReportsData.appUserDatas"
                    v-model="Reports.userId"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(username) => username.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Catalogue")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Catalogue')"
                >
                  <v-select
                    label="name"
                    multiple
                    :options="ReportsData.availableCatalog"
                    v-model="Reports.salesCatalogeDetails"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(name) => name.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createUsercataloge"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ReportsEmptyObj = {
  locale: "en",
  userId: "",
  salesCatalogeDetails: [],
};

export default {
  data() {
    return {
      Reports: ReportsEmptyObj,
      warningPopup: false,
      warningText: "",

      errorMessage: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.catalogueMapping.CreateViewUserCataloge,
    }),
  },
  methods: {
    async createUsercataloge() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      if (!this.Reports.userId || !this.Reports.salesCatalogeDetails) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          await this.$store.dispatch(
            "catalogueMapping/createUsercatalogeAction",
            this.Reports
          );
          this.$swal({
            title: "Success",
            icon: "success",
            text: "User Cataloge Created Successfully!",
            type: "success",
          });
          this.$router.push(`/setup/cataloge-mapping/user`);
          this.resetForm();
        } catch (error) {
          const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
        }
      }
    },
    async getUserCatalogeMappingTemplate() {
      try {
        await this.$store.dispatch(
          "catalogueMapping/setUserCatalogeMappingTemplate",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    resetForm() {
      this.Reports = ReportsEmptyObj;
      this.Reports.userId = "";
      this.Reports.salesCatalogeDetails = "";
      if (this.$refs.observer) {
        this.$refs.observer.reset(); 
      }
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.getUserCatalogeMappingTemplate();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
